module.exports = __webpack_public_path__ + "static/office_entire_page-2fdc2054cbd5f94b05d1708e88fca5ee.png";